/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ENVIRONMENT } from '@gh/config';

@Injectable()
export class IntercomService {
  private window: Window;

  readonly isProd: boolean;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.window = this.document.defaultView as Window;
    this.isProd = ['prod'].includes(ENVIRONMENT);
    if (!this.isProd) {
      console.warn("Intercom doesn't supported in dev mode!");
    }
  }

  showIntercom(): void {
    const intercom = this.window['Intercom'];
    if (this.isProd) {
      intercom('showSpace', 'home');
    }
  }

  trackIntercomEvent(event: string): void {
    const intercom = this.window['Intercom'];
    if (this.isProd) {
      intercom('trackEvent', event);
    }
  }
}
